/**
 * Utility function to determine the correct claims list route based on user roles
 * Ensures users only see claims appropriate to their role
 */
export const getRoleBasedClaimsRoute = (userRoles) => {
  if (!userRoles || !Array.isArray(userRoles)) {
    return '/claims/my-claims';
  }

  // Admins can see all claims
  if (userRoles.includes('Admin')) {
    return '/claims';
  }
  
  // Finance officers see approved claims awaiting payment
  if (userRoles.includes('Finance')) {
    return '/claims?status=APPROVED,PAYMENT_PENDING';
  }
  
  // Approvers see claims awaiting approval
  if (userRoles.includes('Approver')) {
    return '/claims?status=RECOMMENDED_FOR_APPROVAL';
  }
  
  // Claims officers see recently submitted claims for processing
  if (userRoles.includes('Claims_Officer')) {
    return '/claims?status=SUBMITTED,PENDING_VERIFICATION,UNDER_REVIEW,MISSING_DOCUMENTS';
  }
  
  // HR, Broker, CRM see their submitted claims
  if (userRoles.some(role => ['HR', 'Broker', 'CRM'].includes(role))) {
    return '/claims/my-claims';
  }
  
  // Fallback to my-claims for any other roles
  return '/claims/my-claims';
};